import useScript from "@hooks/useScript";
import { cn } from "@util/helpers";

type LiveBlogEmbedProps = {
  /** This is the id of the liveblog. */
  liveblogId: string;
  /** This is the height of the liveblog embed. */
  height: string;
  /** Optional additional styling for the embed container */
  className?: string;
};

/** This is the component for the liveblog embed. */
const LiveBlogEmbed = ({
  liveblogId,
  height,
  className,
}: LiveBlogEmbedProps): React.ReactElement => {
  useScript({ id: "liveblog-embed", src: "https://v.24liveblog.com/24.js" });

  return (
    <iframe
      title={`liveblog-embed-iframe-${liveblogId}`}
      data-testid="liveblog-embed-component"
      name="lb24"
      height={height}
      width="100%"
      className={cn("lb24-iframe", className)}
      src={`//v.24liveblog.com/iframe/?id=${liveblogId}`}
    ></iframe>
  );
};

export default LiveBlogEmbed;
